import { Box } from "@mui/material";
import colors from "../../theme/Colours";
import { styled } from "@mui/material/styles";
import theme from "../../theme/Theme";

export const MainContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.breakpoints.values.xs ? "none" : colors.background2,
  paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.up("sm")]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(3.75),
    paddingBottom: theme.spacing(3.75),
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
  },
  height: "647px",
}));

export const paymentDetailsBoxStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const backIconStyle = {
  cursor: "pointer",
  marginLeft: theme.spacing(8),
};

export const textStyle = {
  fontFamily: "Poppins",
  fontSize: { xs: "12px", sm: "16px" },
  fontWeight: 500,
  marginBottom: { xs: theme.spacing(0.25), sm: theme.spacing(1.25) },
  color: colors.buttonBGColor,
};

export const paytextStyle = {
  ...textStyle,
  color: colors.black,
};
export const headingTextStyle = {
  ...textStyle,
  color: colors.black,
  fontSize: "36px",
  fontWeight: 500,
};

export const headingStyle = {
  ...textStyle,
  fontWeight: 600,
  fontSize: { xs: "10px", sm: "13px", md: "13px" },
  color: colors.greyTextColor,
  marginTop: theme.spacing(1.25),
};

export const inputLabelStyle = {
  ...textStyle,
  fontSize: { xs: "12px", sm: "14px" },
  fontWeight: 500,
  fontFamily: "Roboto",
};
export const uploadButtonContainer = {
  marginTop: theme.spacing(1.25),
  width: "121px",
  height: "43px",
  borderRadius: theme.spacing(0.92), // ~7.37px
  border: `1px solid ${colors.borderGrey}`,
  backgroundColor: colors.background2,
};

export const deviderStyle = {
  width: "225px",
  marginTop: theme.spacing(2.5),
  marginBottom: theme.spacing(2.5),
};

export const lableAndValueStyle = {
  display: "flex",
  flexDirection: "column",
};

export const greyGridStyle = {
  display: "flex",
  flexDirection: "column",
  background: colors.lightBackground,
  paddingY: "23px",
  paddingX: { xs: 0, sm: "23px" },
  borderRadius: "10px",
  height: "593px",
};

export const uploadPaymentStyle = {
  fontSize: { xs: "12px" },
  fontWeight: 400,
  fontFamily: "Roboto",
};

export const fieldTitleStyle = {
  marginBottom: theme.spacing(1),
  fontSize: "14px",
  fontWeight: 500,
  fontFamily: "Roboto",
};

export const transactionInputStyle = {
  width: "300px",
  height: "43px",
  border: `1px solid ${colors.borderGrey}`,
};
export const makePaymentButtonStyle = {
  height: "55px",
  borderRadius: theme.spacing(0.5),
  backgroundColor: colors.primaryButtonOrange,
  "&.Mui-disabled": {
    backgroundColor: colors.primaryButtonOrangeDisabled,
    color: colors.background2,
  },
};

export const uploadDocumentStyle = {
  display: "flex",
  alignItems: "center",
  marginTop: theme.spacing(2),
  fontSize: "12px",
  backgroundColor: colors.background2,
  borderRadius: theme.spacing(0.625),
};

export const uploadSucessImgStyles = {
  width: "14.92xpx",
  height: "16.79px",
  padding: theme.spacing(1.25, 0.625, 1.125, 1.625),
};
export const uploadedFileContainerTextStyles = {
  fileName: {
    fontFamily: "DM Sans",
    fontWeight: 700,
    fontSize: "8.7px",
    color: colors.darkGrey,
  },
  uploadedText: {
    fontFamily: "DM Sans",
    fontWeight: 500,
    fontSize: "8.7px",
    leadingTrim: "Cap height",
    color: colors.uploadedTextBlue,
  },
};

export const fileUploadStyle = {
  display: "none",
  backgroundColor: colors.fileUploadBG,
};

export const noFileSelectedStyles = {
  marginTop: theme.spacing(1.25),
  paddingLeft: theme.spacing(1.25),
  fontSize: "14px",
  fontWeight: 400,
  fontFamily: "Roboto",
  color: colors.black,
};
